export const SMS_FIELD = 'MOBILE';
export const EMAIL_FIELD = 'MAIL';
export const WHATS_APP_FIELD = 'WHATSAPP';
